import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../../../models/user.model';
import {UserService} from '../../../../services/users.service';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, SelectItem} from 'primeng/primeng';

@Component({
  providers: [UserService],
  selector: 'app-user-details',
  templateUrl: './users.details.component.html'
})
export class UsersDetailsComponent implements OnDestroy, OnInit {
  public user: User;
  public userRoles: SelectItem[];
  public setNewPassword = false;
  public newPassword = '';
  public newPasswordRepeat = '';
  public error: string;

  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, public router: Router, private _userService: UserService,
              private confirmationService: ConfirmationService) {
    this.userRoles = [];
    this.userRoles.push({label: 'Admin', value: 'admin'});
    this.userRoles.push({label: 'User', value: 'user'});
  }

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const userId = params['id'];

        if (userId) {
          this._userService.load(userId);
          this._userService.users$
            .takeUntil(this._ngUnSubscribe)
            .subscribe(
              users => {
                this.user = users.find(pr => pr._id === userId);
              }
            );
        }
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public deleteUser(): void {
    this.confirmationService.confirm({
      message: 'Weet u het zeker dat u de gebruiker wilt verwijderen?',
      accept: () => {
        this._userService.remove(this.user._id)
          .subscribe(response => {
            this.router.navigate(['/users']);
          });
      }
    });
  }

  public saveUser(): void {
    let valid = true;

    if (this.user.email === '') {
      this.error = 'Email is verplicht.';
      valid = false;
    }

    if (this.setNewPassword) {
      if (this.newPassword === '') {
        this.error = 'Het wachtwoord mag niet leeg zijn.';
        valid = false;
      }

      if (this.newPassword !== this.newPasswordRepeat) {
        this.error = 'De wachtwoorden komen niet overeen.';
        valid = false;
      }
    }

    if (this.user.name === '') {
      this.error = 'Naam is verplicht.';
      valid = false;
    }

    if (valid) {
      if (this.setNewPassword) {
        this.user.password = this.newPassword;
      }
      this._userService.update(this.user)
        .subscribe(customer => {
          this.router.navigate(['/users']);
        });
    }
  }

  public cancel(): void {
    this.router.navigate(['/users']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/users/details/users.details.component.ts